import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleResourceManager } from "../hooks/roles/ProtectedRoleResourceManager";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const ResultsManager = React.lazy(
  () => import("../screean/Rm/rm-tarea-programada")
);
export function tareaProgramada() {
  return (
    <Route
      path="/tarea-programada"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleResourceManager>
              <LazySuspense>
                <ResultsManager />
              </LazySuspense>
            </ProtectedRoleResourceManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
